import type { Options } from './Shared'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { CheckboxState } from '@sunwebgroup/ui-components/src/uds'
import { CheckboxField } from '@sunwebgroup/ui-components/uds'
import { equals, reject } from 'ramda'
import * as React from 'react'
import { styled } from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${space('primitives_space_16')};
  padding-right: ${space('primitives_space_16')};
  padding-bottom: ${space('primitives_space_16')};

  &:first-child {
    padding-top: ${space('primitives_space_16')};
  }
`

export const Footer = styled.div`
  display: flex;
  gap: ${space('primitives_space_8')};
  position: sticky;
  bottom: 0;
  background-color: ${tok('semantics_views_background_color')};
  padding: ${space('primitives_space_16')};
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
`

interface FilterProps {
  options: Options[]
  selectedValues: string[]
  onSelectedValueChange: (newSelectedValue: string[]) => void
}

export function Root({ options, selectedValues, onSelectedValueChange }: FilterProps) {
  function handleCheckedChange(checked: CheckboxState, value: string) {
    if (checked) {
      onSelectedValueChange([...selectedValues, String(value)])
    }

    if (!checked) {
      onSelectedValueChange(reject(equals(value), selectedValues))
    }
  }

  return (
    <Content>
      {options.map((option, index) => (
        <CheckboxField
          key={index}
          label={option.name}
          name={option.name}
          value={option.value}
          onCheckedChange={checked => handleCheckedChange(checked, option.value)}
          defaultChecked={selectedValues.includes(option.value)}
        />
      ))}
    </Content>
  )
}
